import Vue from "vue"
import { AxiosError } from "axios"
import {
    notifyRequestError as _notifyRequestError,
    notifyError as _notifyError,
    notifySuccess as _notifySuccess,
    notifyInfo as _notifyInfo,
    notifyRequestTimeout as _notifyRequestTimeout,
    notifyWarn as _notifyWarn,
} from "@/utils/notify"
import Component from "vue-class-component"

@Component
export default class Notify extends Vue {
    public notifyRequestError(error: AxiosError, title = "", text = ""): void {
        _notifyRequestError(error, title, text)
    }
    public notifyRequestTimeout() {
        _notifyRequestTimeout()
    }
    public notifyInfo(title = "", text = "") {
        _notifyInfo(title, text)
    }
    public notifySuccess(title = "", text = "") {
        _notifySuccess(title, text)
    }
    public notifyError(title = "", text = "") {
        _notifyError(title, text)
    }
    public notifyWarn(title = "", text = "") {
        _notifyWarn(title, text)
    }
}
